var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPageWeb(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 122,
    height: 122,
    viewBox: "0 0 122 122",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_48",
    "data-name": "Group 48",
    transform: "translate(-200 -7598)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_11",
    "data-name": "Ellipse 11",
    cx: 61,
    cy: 61,
    r: 61,
    transform: "translate(200 7598)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "browser",
    transform: "translate(226.675 7624.675)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_73",
    "data-name": "Group 73",
    transform: "translate(5.721 19.451)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_72",
    "data-name": "Group 72"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_91",
    "data-name": "Path 91",
    d: "M98.731,145.067H43.811a1.144,1.144,0,0,0-1.144,1.144V167.95a1.144,1.144,0,0,0,1.144,1.144h54.92a1.144,1.144,0,0,0,1.144-1.144V146.211A1.144,1.144,0,0,0,98.731,145.067Zm-1.144,21.739H44.955V147.355H97.587v19.451Z",
    transform: "translate(-42.667 -145.067)",
    fill: "#ed8e88"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_75",
    "data-name": "Group 75",
    transform: "translate(22.883 30.892)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_74",
    "data-name": "Group 74"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_92",
    "data-name": "Path 92",
    d: "M177.194,230.733a1.143,1.143,0,0,0-1.618,0L171,235.309a1.144,1.144,0,1,0,1.618,1.618l4.577-4.577A1.143,1.143,0,0,0,177.194,230.733Z",
    transform: "translate(-170.664 -230.397)",
    fill: "#ed8e88"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_77",
    "data-name": "Group 77",
    transform: "translate(27.46 30.892)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_76",
    "data-name": "Group 76"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_93",
    "data-name": "Path 93",
    d: "M211.327,235.31l-4.577-4.577a1.144,1.144,0,1,0-1.618,1.618l4.577,4.577a1.144,1.144,0,0,0,1.618-1.618Z",
    transform: "translate(-204.797 -230.397)",
    fill: "#ed8e88"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_79",
    "data-name": "Group 79",
    transform: "translate(29.748 28.604)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_78",
    "data-name": "Group 78"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_94",
    "data-name": "Path 94",
    d: "M228.394,213.667a1.143,1.143,0,0,0-1.618,0l-4.577,4.577a1.144,1.144,0,1,0,1.618,1.618l4.577-4.577A1.143,1.143,0,0,0,228.394,213.667Z",
    transform: "translate(-221.864 -213.331)",
    fill: "#ed8e88"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_81",
    "data-name": "Group 81",
    transform: "translate(34.325 28.604)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_80",
    "data-name": "Group 80"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_95",
    "data-name": "Path 95",
    d: "M262.529,218.243l-4.577-4.577a1.144,1.144,0,1,0-1.618,1.618l4.577,4.577a1.144,1.144,0,1,0,1.618-1.618Z",
    transform: "translate(-255.999 -213.331)",
    fill: "#ed8e88"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_83",
    "data-name": "Group 83"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_82",
    "data-name": "Group 82"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_96",
    "data-name": "Path 96",
    d: "M63.5,0H5.149A5.155,5.155,0,0,0,0,5.149V63.5A5.155,5.155,0,0,0,5.149,68.65H63.5A5.155,5.155,0,0,0,68.65,63.5V5.149A5.155,5.155,0,0,0,63.5,0Zm2.86,63.5a2.863,2.863,0,0,1-2.86,2.86H5.149a2.864,2.864,0,0,1-2.86-2.86V5.149a2.864,2.864,0,0,1,2.86-2.86H63.5a2.864,2.864,0,0,1,2.86,2.86Z",
    fill: "#ed8e88"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_85",
    "data-name": "Group 85",
    transform: "translate(4.577 4.577)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_84",
    "data-name": "Group 84"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_97",
    "data-name": "Path 97",
    d: "M39.855,34.133H35.278a1.144,1.144,0,0,0-1.144,1.144v4.577A1.144,1.144,0,0,0,35.278,41h4.577A1.144,1.144,0,0,0,41,39.854V35.277A1.144,1.144,0,0,0,39.855,34.133ZM38.711,38.71H36.422V36.421h2.288Z",
    transform: "translate(-34.134 -34.133)",
    fill: "#ed8e88"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_87",
    "data-name": "Group 87",
    transform: "translate(13.73 4.577)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_86",
    "data-name": "Group 86"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_98",
    "data-name": "Path 98",
    d: "M108.122,34.133h-4.577a1.144,1.144,0,0,0-1.144,1.144v4.577A1.144,1.144,0,0,0,103.545,41h4.577a1.144,1.144,0,0,0,1.144-1.144V35.277A1.144,1.144,0,0,0,108.122,34.133Zm-1.144,4.577h-2.288V36.421h2.288Z",
    transform: "translate(-102.401 -34.133)",
    fill: "#ed8e88"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_89",
    "data-name": "Group 89",
    transform: "translate(22.883 4.577)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_88",
    "data-name": "Group 88"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_99",
    "data-name": "Path 99",
    d: "M176.388,34.133h-4.577a1.144,1.144,0,0,0-1.144,1.144v4.577A1.144,1.144,0,0,0,171.811,41h4.577a1.144,1.144,0,0,0,1.144-1.144V35.277A1.144,1.144,0,0,0,176.388,34.133Zm-1.144,4.577h-2.288V36.421h2.288Z",
    transform: "translate(-170.667 -34.133)",
    fill: "#ed8e88"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_91",
    "data-name": "Group 91",
    transform: "translate(41.19 24.027)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_90",
    "data-name": "Group 90"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_100",
    "data-name": "Path 100",
    d: "M311.75,179.2h-2.236a2.317,2.317,0,0,0-2.315,2.315v2.237a2.316,2.316,0,0,0,2.315,2.313h2.236a2.317,2.317,0,0,0,2.315-2.315v-2.237A2.316,2.316,0,0,0,311.75,179.2Zm.026,4.552a.026.026,0,0,1-.026.025l-2.262-.025.026-2.263,2.262.026Z",
    transform: "translate(-307.2 -179.2)",
    fill: "#ed8e88"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_93",
    "data-name": "Group 93"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_92",
    "data-name": "Group 92"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_101",
    "data-name": "Path 101",
    d: "M63.5,0H5.149A5.155,5.155,0,0,0,0,5.149v9.725a1.144,1.144,0,0,0,1.144,1.144H67.506a1.144,1.144,0,0,0,1.144-1.144V5.149A5.155,5.155,0,0,0,63.5,0Zm2.86,13.73H2.288V5.149a2.864,2.864,0,0,1,2.86-2.86H63.5a2.864,2.864,0,0,1,2.86,2.86Z",
    fill: "#ed8e88"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_95",
    "data-name": "Group 95",
    transform: "translate(5.721 46.911)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_94",
    "data-name": "Group 94"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_102",
    "data-name": "Path 102",
    d: "M85,349.867H43.811a1.144,1.144,0,1,0,0,2.288H85a1.144,1.144,0,1,0,0-2.288Z",
    transform: "translate(-42.667 -349.867)",
    fill: "#ed8e88"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_97",
    "data-name": "Group 97",
    transform: "translate(52.632 46.911)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_96",
    "data-name": "Group 96"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_103",
    "data-name": "Path 103",
    d: "M401.687,349.867h-8.009a1.144,1.144,0,0,0,0,2.288h8.009a1.144,1.144,0,1,0,0-2.288Z",
    transform: "translate(-392.534 -349.867)",
    fill: "#ed8e88"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_99",
    "data-name": "Group 99",
    transform: "translate(19.451 51.487)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_98",
    "data-name": "Group 98"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_104",
    "data-name": "Path 104",
    d: "M187.4,384h-41.19a1.144,1.144,0,1,0,0,2.288H187.4a1.144,1.144,0,1,0,0-2.288Z",
    transform: "translate(-145.067 -384)",
    fill: "#ed8e88"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_101",
    "data-name": "Group 101",
    transform: "translate(5.721 51.487)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_100",
    "data-name": "Group 100"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_105",
    "data-name": "Path 105",
    d: "M51.82,384H43.811a1.144,1.144,0,1,0,0,2.288H51.82a1.144,1.144,0,0,0,0-2.288Z",
    transform: "translate(-42.667 -384)",
    fill: "#ed8e88"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_103",
    "data-name": "Group 103",
    transform: "translate(5.721 56.064)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_102",
    "data-name": "Group 102"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_106",
    "data-name": "Path 106",
    d: "M85,418.133H43.811a1.144,1.144,0,0,0,0,2.288H85a1.144,1.144,0,0,0,0-2.288Z",
    transform: "translate(-42.667 -418.133)",
    fill: "#ed8e88"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_105",
    "data-name": "Group 105",
    transform: "translate(52.632 56.064)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_104",
    "data-name": "Group 104"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_107",
    "data-name": "Path 107",
    d: "M401.687,418.133h-8.009a1.144,1.144,0,0,0,0,2.288h8.009a1.144,1.144,0,1,0,0-2.288Z",
    transform: "translate(-392.534 -418.133)",
    fill: "#ed8e88"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_107",
    "data-name": "Group 107",
    transform: "translate(19.451 60.641)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_106",
    "data-name": "Group 106"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_108",
    "data-name": "Path 108",
    d: "M187.4,452.267h-41.19a1.144,1.144,0,1,0,0,2.288H187.4a1.144,1.144,0,1,0,0-2.288Z",
    transform: "translate(-145.067 -452.267)",
    fill: "#ed8e88"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_109",
    "data-name": "Group 109",
    transform: "translate(5.721 60.641)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_108",
    "data-name": "Group 108"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_109",
    "data-name": "Path 109",
    d: "M51.82,452.267H43.811a1.144,1.144,0,1,0,0,2.288H51.82a1.144,1.144,0,0,0,0-2.288Z",
    transform: "translate(-42.667 -452.267)",
    fill: "#ed8e88"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPageWeb);
export default __webpack_public_path__ + "static/media/pageWeb.3b735d42783a4a8dfc66a24db9ae3b45.svg";
export { ForwardRef as ReactComponent };